import { MobiDocument } from './MobiDocument';
import { VieQuoRegimeAliDocument } from './VieQuoRegimeAliDocument';

export class VieQuotidienneDocuments extends MobiDocument {
    private _id: string;
    private _rev: string;
    private id: number;
    private intitule: string;
    private dtype: string;
    private defaut: boolean;

    public constructor(viequo: any) {
        super();
        this._id = viequo._id;
        this._rev = viequo._rev;
        this.id = viequo.id;
        this.intitule = viequo.intitule;
        this.dtype = viequo.dtype;
        this.defaut = viequo.defaut;
    }

    public get_id(): string {
        return this._id;
    }

    public set_id(_id: string): void {
        this._id = _id;
    }

    public get_rev(): string {
        return this._rev;
    }

    public set_rev(_rev: string): void {
        this._rev = _rev;
    }

    public getId(): number {
        return this.id;
    }

    public setId(id: number): void {
        this.id = id;
    }

    public getIntitule(): string {
        return this.intitule;
    }

    public setIntitule(intitule: string): void {
        this.intitule = intitule;
    }

    public getDtype(): string {
        return this.dtype;
    }

    public setDtype(dtype: string): void {
        this.dtype = dtype;
    }

    public isDefaut(): boolean {
        return this.defaut;
    }

    public setDefaut(defaut: boolean): void {
        this.defaut = defaut;
    }

    public getVieQuoRegimeAli(): VieQuoRegimeAliDocument {
        try {
            return this.memdb.findOne({
                doctype: "VieQuoRegimeAliDocument",
                fkey: "viequo_id",
                fvalue: this.id
            })
        } catch (error) {
            console.warn(`Impossibe de récup les détails de ${this.getIntitule()}`);
            return new VieQuoRegimeAliDocument({
                _id : 'VieQuoRegimeAliDocument_-999',
                id : -999,
                viequo_id : -99,
                type_regime : 'Introuvable'
            })
        }
    }
}